const pillars = [
  {
    zh: '一味',
    en: 'FLAVOR',
    desc: '中国美食。',
    detail: '鱼、面、汤、糕点、火锅……不同的味道，记录着不同地域的生活。',
    icon: 'ri-restaurant-line',
    wrap: 'bg-primary-50 border-primary-200/70',
    bubble: 'bg-primary-100 text-primary-700',
    accent: 'text-primary-600',
  },
  {
    zh: '一境',
    en: 'PLACE',
    desc: '东方风土。',
    detail: '阳光、土地、山川、湖水、清风、绿叶，构成角色所生活的世界。',
    icon: 'ri-landscape-line',
    wrap: 'bg-secondary-50 border-secondary-200/70',
    bubble: 'bg-secondary-100 text-secondary-700',
    accent: 'text-secondary-700',
  },
  {
    zh: '一愿',
    en: 'WISH',
    desc: '当代人的愿望。',
    detail: '纳福、聚财、姻缘、健康、事业、团圆，让食物从「好吃」变成「有意义」。',
    icon: 'ri-heart-3-line',
    wrap: 'bg-accent-50 border-accent-200/70',
    bubble: 'bg-accent-100 text-accent-700',
    accent: 'text-accent-700',
  },
];

export default function WhatIs() {
  return (
    <section id="world" className="relative bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="reveal lg:col-span-7 lg:pr-6">
            <div className="mb-6 flex items-center gap-3">
              <span className="text-[11px] tracking-[0.34em] text-primary-600 uppercase">
                Section 01
              </span>
              <span className="h-px w-8 bg-primary-300"></span>
              <span className="text-[11px] tracking-[0.28em] text-foreground-400 uppercase">
                What is NOMOISM
              </span>
            </div>

            <p className="max-w-2xl text-base leading-loose text-foreground-700 md:text-lg md:leading-loose">
              NOMOISM 从中国美食出发，提炼食物背后的地域文化、自然风物与生活寓意，
              并用当代潮玩的语言重新演绎——让每一种中国味道，都可以成为一个有性格的角色。
            </p>

            <div className="mt-10 inline-flex items-center gap-3 rounded-full border border-background-200/70 bg-background-100 px-5 py-2.5">
              <span className="font-heading tracking-[0.24em] text-foreground-950">NOMOISM</span>
              <span className="text-foreground-300">·</span>
              <span className="text-xs tracking-[0.16em] text-primary-600">东方潮玩</span>
            </div>
          </div>

          <div className="reveal lg:col-span-5" style={{ transitionDelay: '160ms' }}>
            <div className="relative h-[340px] w-full overflow-hidden rounded-lg bg-background-200 md:h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20still%20life%20of%20a%20warm%20bowl%20of%20Chinese%20soup%20with%20soft%20steam%20beside%20two%20small%20cute%20collectible%20art%20toy%20figures%20on%20a%20rice%20paper%20surface%20warm%20amber%20cream%20and%20cinnabar%20red%20tones%20minimal%20eastern%20aesthetic%20editorial%20photography%20soft%20natural%20light&width=900&height=1200&seq=nomo-whatis-01&orientation=portrait"
                alt="中国味道与 NOMOISM 潮玩角色的东方静物意象"
                title="NOMOISM 中国美食 · 东方潮玩"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
          {pillars.map((pillar, index) => (
            <article
              key={pillar.zh}
              className={`reveal rounded-lg border p-6 md:p-7 ${pillar.wrap}`}
              style={{ transitionDelay: `${index * 120}ms` }}
            >
              <div
                className={`mb-5 flex h-11 w-11 items-center justify-center rounded-full ${pillar.bubble}`}
              >
                <i className={`${pillar.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-xl text-foreground-950">
                {pillar.zh}
                <span className="ml-2 text-[11px] tracking-[0.2em] text-foreground-400 uppercase">
                  {pillar.en}
                </span>
              </h3>
              <p className={`mt-2 text-sm font-medium ${pillar.accent}`}>{pillar.desc}</p>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{pillar.detail}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}